export const METHODS_POST = 'post';
export const METHODS_GET = 'get';
export const TOKEN_NAME = 'sessionToken';
export const HEADER_TOKEN_NAME = 'x-token';

import productionApis from './productionApis';
import thirdCtripApis from './thirdCtipApis';
import thirdTaimeiApis from './thirdTaimeiApis';
import dict from './dict';

/**
 * 接口列表，具体查看./index.js中实现，具体支持多种格式:
 * 1. [apiName]: Function (params) => {}        将调用改function，并将结果返回
 * 2. [apiName]: Array    []                    将直接返回Array定义的数据
 * 3. [apiName]: Object   {d,data}              将直接返回 Object.data || Object.d 定义的数据
 * 4. [apiName]: Object   {path,method,noAuth}  将调用 api[method](args)方法并返回结果
 */
export let apiList = {
  getHomepagePublic: {
    path: '/ump/v1/home/public',
    method: METHODS_GET,
  },
  getCompanySettings: {
    path: '/ump/v1/settings',
    method: METHODS_GET,
  },
  sendSMS: {
    path: '/ump/v1/sms',
    method: METHODS_POST,
    noAuth: true,
  },
  loginWithCode: {
    path: '/ump/v1/users',
    method: 'post',
    noAuth: true,
  },
  //我的订单列表
  getMyReceipts: {
    path: '/ump/v1/receipts',
    method: METHODS_GET,
  },

};

/**
 * 加载mock资源
 */
// if (import.meta.env.VITE_USE_MOCK) {
//   apiList = { ...apiList };
// }

apiList = { ...apiList, ...productionApis, ...thirdCtripApis, ...thirdTaimeiApis, ...dict };
